// @import

import { ensureHTMLNodeList } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";

Alpine.directive("logos", (element, {}, { cleanup, effect }) => {
  const dom = {
    logos: ensureHTMLNodeList(element.querySelectorAll(".c-logos__logo")),
    moreBtn: element.querySelector(".c-logos__show-more"),
  };

  if (!dom.moreBtn) return;

  const totalLogos = dom.logos.length;
  let perPage = viewport.width > 768 ? 16 : 10;
  let totalPages = Math.ceil(totalLogos / perPage);
  let currentPage = 1;

  function applyPaginate() {
    const start = (currentPage - 1) * perPage;
    const end = currentPage * perPage;
    console.log({ start, end });
    dom.logos.forEach((logo, index) => {
      if (index < end) {
        logo.classList.remove("c-logos__logo--hidden");
      } else {
        logo.classList.add("c-logos__logo--hidden");
      }
    });

    const allLogosDisplayed = Array.from(dom.logos).every(
      (logo) => !logo.classList.contains("c-logos__logo--hidden"),
    );

    if (allLogosDisplayed) {
      dom.moreBtn?.classList.add("c-logos__show-more--hidden");
    } else {
      dom.moreBtn?.classList.remove("c-logos__show-more--hidden");
    }
  }

  function showMoreLogos() {
    if (currentPage < totalPages) {
      currentPage++;
      applyPaginate();
    }
  }

  effect(() => {
    onResize();
    applyPaginate();
    console.log({ totalLogos, perPage, totalPages });
  });

  function onResize() {
    if (viewport.width > 768) {
      perPage = 16;
      totalPages = Math.ceil(totalLogos / perPage);
    } else {
      perPage = 10;
      totalPages = Math.ceil(totalLogos / perPage);
    }
  }

  dom.moreBtn?.addEventListener("click", showMoreLogos);

  cleanup(() => {
    dom.moreBtn?.removeEventListener("click", showMoreLogos);
  });
});
